import api from './api';

/**
 * The environment's sign-in policy, as the server describes it.
 *
 * Read once at startup so the login page offers only the methods the server
 * will accept, asks Microsoft for the right directory, and the sign-up page
 * knows which email domains may register. The server enforces the same
 * policy on every authenticated request; this only shapes what is shown.
 */
export const DEFAULT_AUTH_CONFIG = {
    methods: ['password', 'microsoft'],
    password: { allowedDomains: [] },
    microsoft: { tenant: process.env.REACT_APP_MICROSOFT_TENANT || 'common' },
};

export const authConfigService = {
    async getAuthConfig() {
        const response = await api.get('/auth/config');
        return response.data;
    },
};

export default authConfigService;
